import React, { useContext, useEffect, useState } from 'react';
import GridLayout from 'react-grid-layout';
import ErrorBoundary from '../../../common/error-boundary';
import { AppContext } from '../../../../contexts/AppContext';
import { ConfigProvider } from 'antd';
import { NAME_PATH, useTralitSetting } from '../../../../hooks/useTralitSetting';

const UnlimitedComponentContainer: React.FC<any> = (props) => {
  const { components, width, autoLayout = true, rowHeight = 22 } = props;
  const { fontSize } = useTralitSetting({ namePath: NAME_PATH.PREFERENCE });
  const { allComponents } = useContext(AppContext);
  const [layoutItems, setLayoutItems] = useState<any>([]);

  useEffect(() => {
    setLayoutItems(components);
  }, [components]);

  const onLayoutChange = () => {};

  return (
    <>
      <GridLayout
        autoSize
        className="layout"
        cols={24}
        rowHeight={rowHeight}
        width={width}
        layout={layoutItems}
        onLayoutChange={onLayoutChange}
        margin={[0, 0]}
        isDraggable={false}
        isResizable={false}
        isDroppable={false}
      >
        {layoutItems.map((layout, index) => {
          return (
            <div
              key={layout.i}
              className={`draggable-element-container ${autoLayout ? 'auto-layout' : ''}`}
              style={{
                padding: layout.padding && layout.padding.length > 0 ? layout.padding : 0,
                margin: layout.margin && layout.margin.length > 0 ? layout.margin : 0,
              }}
            >
              <div
                style={{
                  height: '100%',
                }}
              >
                <ConfigProvider
                  theme={{
                    components: {
                      Table: {
                        cellFontSize: fontSize.table,
                        cellFontSizeMD: fontSize.table,
                        cellFontSizeSM: fontSize.table,
                      },
                    },
                  }}
                >
                  <ErrorBoundary>
                    {allComponents && allComponents[layout.type] && allComponents[layout.type].component ? (
                      React.cloneElement(allComponents[layout.type].component, {
                        property: layout,
                      })
                    ) : layout.copyFrom && allComponents && allComponents[layout.copyFrom] && allComponents[layout.copyFrom].component ? (
                      React.cloneElement(allComponents[layout.copyFrom].component, {
                        property: layout,
                      })
                    ) : (
                      <></>
                    )}
                  </ErrorBoundary>
                </ConfigProvider>
              </div>
            </div>
          );
        })}
      </GridLayout>
    </>
  );
};

export default UnlimitedComponentContainer;
